/* @flow */

import * as types from 'src/shared/app/authentication/action/base/authenticationActionTypes';
import { saveTokenInCookie } from 'src/shared/app/base/util/tokenUtils';
import * as signupTypes from 'src/shared/app/signup/action/signupActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';
import { isClient } from 'src/shared/core/util/ssrUtil';

/*
|------------------------------------------------------------------------------
| INITIAL STATE
|------------------------------------------------------------------------------
*/

export const initialState = {
  token: '',
  tokenPassedAsQueryParam: false,
  resetToken: '',
  uid: '',
  cid: '',
  email: '',
  url: '',
  isPasswordSet: false,
  isPasswordLinkSent: false,
  isPasswordLinkInvalid: false,
  isPasswordReset: false,
};

/*
|------------------------------------------------------------------------------
| REDUCERS
|------------------------------------------------------------------------------
*/

const _setToken = (state: Object, action: Object): Object => {
  const { token, tokenPassedAsQueryParam, event } = action;
  // @TODO - TEMP-AUTH
  if (isClient) {
    // @TODO - TEMP-AUTH Use env provider
    saveTokenInCookie(token, !process.env.DEV_MODE, event);
    return {
      ...state,
      tokenPassedAsQueryParam,
    };
  }
  return {
    ...state,
    token,
    tokenPassedAsQueryParam,
  };
};

const _unsetToken = (state: Object): Object => ({
  ...state,
  token: '',
  tokenPassedAsQueryParam: false,
});

const _setAuthenticationEmail = (state: Object, action: Object): Object => {
  const { email } = action;

  return {
    ...state,
    email,
  };
};

const _unsetAuthenticationEmail = (state: Object): Object => ({
  ...state,
  email: '',
});

const _setAuthenticationUid = (state: Object, action: Object): Object => {
  const { uid } = action;

  return {
    ...state,
    uid,
  };
};

const _unsetAuthenticationUid = (state: Object): Object => ({
  ...state,
  uid: '',
});

const _setAuthenticationCid = (state: Object, action: Object): Object => {
  const { cid } = action;

  return {
    ...state,
    cid,
  };
};

const _unsetAuthenticationCid = (state: Object): Object => ({
  ...state,
  cid: '',
});

const _setAuthenticationResetToken = (
  state: Object,
  action: Object,
): Object => {
  const { token } = action;

  return {
    ...state,
    resetToken: token,
  };
};

const _unsetAuthenticationResetToken = (state: Object): Object => ({
  ...state,
  resetToken: '',
});

const _checkPassword = (state: Object, action: Object): Object => {
  const { email, isPasswordSet } = action;

  return {
    ...state,
    email,
    isPasswordSet,
  };
};

const _toggleOffPasswordLinkSent = (state: Object): Object => ({
  ...state,
  isPasswordLinkSent: false,
});

const _toggleOnPasswordLinkSent = (state: Object, action: Object): Object => {
  const { email } = action;

  return {
    ...state,
    email,
    isPasswordLinkSent: true,
  };
};

const _toggleOffPasswordLinkInvalid = (state: Object): Object => ({
  ...state,
  isPasswordLinkInvalid: false,
});

const _toggleOnPasswordLinkInvalid = (state: Object): Object => ({
  ...state,
  isPasswordLinkInvalid: true,
});

const _toggleOnPassordReset = (state: Object, action: Object): Object => {
  const { token } = action;

  return {
    ...state,
    token,
    tokenPassedAsQueryParam: false,
    isPasswordReset: true,
  };
};

const _setInitialUrl = (state: Object, action: Object): Object => {
  const { url } = action;

  return {
    ...state,
    url,
  };
};

const _resetInitialUrl = (state: Object): Object => ({
  ...state,
  url: '',
});

/*
|------------------------------------------------------------------------------
| REDUCER
|------------------------------------------------------------------------------
*/

export default createReducer(initialState, {
  [types.SET_AUTHENTICATION_TOKEN]: _setToken,
  [types.UNSET_AUTHENTICATION_TOKEN]: _unsetToken,
  [types.SET_AUTHENTICATION_EMAIL]: _setAuthenticationEmail,
  [types.UNSET_AUTHENTICATION_EMAIL]: _unsetAuthenticationEmail,
  [types.SET_AUTHENTICATION_UID]: _setAuthenticationUid,
  [types.UNSET_AUTHENTICATION_UID]: _unsetAuthenticationUid,
  [types.SET_AUTHENTICATION_CID]: _setAuthenticationCid,
  [types.UNSET_AUTHENTICATION_CID]: _unsetAuthenticationCid,
  [types.SET_AUTHENTICATION_RESET_TOKEN]: _setAuthenticationResetToken,
  [types.UNSET_AUTHENTICATION_RESET_TOKEN]: _unsetAuthenticationResetToken,
  [types.VALIDATE_EMAIL_SUCCESS]: _checkPassword,
  [types.CREATE_PASSWORD_SUCCESS]: _setToken,
  [types.SEND_PASSWORD_LINK_REQUEST]: _toggleOffPasswordLinkSent,
  [types.SEND_PASSWORD_LINK_FAILURE]: _toggleOffPasswordLinkSent,
  [types.SEND_PASSWORD_LINK_SUCCESS]: _toggleOnPasswordLinkSent,
  [types.VALIDATE_PASSWORD_LINK_REQUEST]: _toggleOffPasswordLinkInvalid,
  [types.VALIDATE_PASSWORD_LINK_SUCCESS]: _toggleOffPasswordLinkInvalid,
  [types.VALIDATE_PASSWORD_LINK_FAILURE]: _toggleOnPasswordLinkInvalid,
  [types.RESET_PASSWORD_LINK_SENT]: _toggleOffPasswordLinkSent,
  [types.RESET_PASSWORD_SUCCESS]: _toggleOnPassordReset,
  [types.LOGIN_SUCCESS]: _setToken,
  [signupTypes.SIGNUP_CREATE_USER_SUCCESS]: _setToken,
  [types.LOGIN_FAILURE]: _unsetToken,
  [types.SAVE_INITIAL_URL]: _setInitialUrl,
  [types.RESET_INITIAL_URL]: _resetInitialUrl,
});
